import { Injectable, NgZone } from '@angular/core';
import { navigation } from 'src/app/navigation/navigation';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { CcmcApiService } from './ccmc-api.service';
import { Router } from '@angular/router';
import { SpinnerService } from './spinner.service';
import { ActiveLosService } from './active-los.service';
import { CustomErrorHandlerService } from './custom-error-handler.service';
import { AssetService } from './asset.service';
import { filter, catchError } from 'rxjs/operators';
import { ErrorDialogComponent } from '../components/error-dialog/error-dialog.component';
import { SuccessDialogComponent } from '../components/success-dialog/success-dialog.component';
import { environment } from 'src/environments/environment';
import { CaptureDataService } from './capture-data.service';
import { AmplifyService } from './amplify.service';
import { GlobalSearchService } from './global-search.service';
import { TargetResponseDialogComponent } from '../components/target-response-dialog/target-response-dialog.component';
import { DebitCeditCheckDialogComponent } from '../components/debit-cedit-check-dialog/debit-cedit-check-dialog.component';
const { Buffer } = require('buffer');

const MONETARY_GL_FIELD = 'MSG_005';
const CREDIT_DEBIT_FIELD = 'MON*_004';
const GL_AMOUNT_FIELD = 'MON*_007';

@Injectable({
  providedIn: 'root'
})
export class InsightService {
  dynamicNav: any = navigation;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  constructor(
    private dialog: MatDialog,
    private ccmcApiService: CcmcApiService,
    public router: Router,
    private spinnerService: SpinnerService,
    private activeLosService: ActiveLosService,
    private zone: NgZone,
    private http: HttpClient,
    private customErrorHandlerService: CustomErrorHandlerService,
    private assetService: AssetService,
    private amplifyService: AmplifyService,
    private captureDataService: CaptureDataService,
    private globalSearchService: GlobalSearchService
  ) {
    this.httpOptions.headers.append('Access-Control-Allow-Origin', '*');
    this.httpOptions.headers.append(
      'Access-Control-Allow-Methods',
      'POST, GET, OPTIONS, PUT'
    );
    this.httpOptions.headers.append('Accept', 'application/json');
  }

  async send() {
    if (!await this.insightBalanceCheck()) {
      this.spinnerService.setShowSpinner(false);
      return;
    }
    //   turn spinner on
    this.spinnerService.setShowSpinner(true);
    // init username
    let userName = this.amplifyService.username;
    // init export object
    const exportObject = {
      content: {
        mapping: this.ccmcApiService.mapping,
        configurations: this.ccmcApiService.configurations,
        transactions: this.ccmcApiService.transactions
      },
      user: userName,
      assetID: this.assetService.getSelectedAssetId()
    };
    // Call export
    this.export(exportObject).subscribe(async res => {
      console.log('export response: ', res);
      const parsedResult = JSON.parse(JSON.stringify(res));
      if (parsedResult.error) {
        const errorMessage = {
          statusMessage: "Ground Control failed to receive a response back from the communicator",
          statusFlag: false
        };
        const dialogRef2 = this.zone.run(() => {
          this.dialog.open(TargetResponseDialogComponent, {
            data: errorMessage
          });
        });
        await this.ccmcApiService.logExportResponse({
          assetID: this.assetService.getSelectedAssetId(),
          loanNumber: '',
          statusMessage: parsedResult.statusMessage,
          statusFlag: parsedResult.statusFlag
        });
      }
      if (parsedResult.statusFlag === true) {
        let loanNumber;
        if (parsedResult.loanNumber) {
          loanNumber = parsedResult.loanNumber;
        } else {
          loanNumber = this.ccmcApiService.loanNumber;
        }
        const resultMessage = {
          statusMessage: parsedResult.statusMessage,
          loanNumber: loanNumber,
          statusFlag: true
        };
        await this.ccmcApiService.logExportResponse({
          assetID: this.assetService.getSelectedAssetId(),
          loanNumber: loanNumber,
          statusMessage: parsedResult.statusMessage,
          statusFlag: parsedResult.statusFlag
        });

        this.captureDataService.uploadS3File(this.ccmcApiService.mapping);
        this.activeLosService.activeLosService.loanBooked(
          parsedResult,
          JSON.parse(JSON.stringify(this.ccmcApiService.configurations))
        );
        this.ccmcApiService.mapping = undefined;
        this.ccmcApiService.coreSettings = undefined;
        this.ccmcApiService.conditions = undefined;
        this.ccmcApiService.mapping = undefined;
        this.ccmcApiService.supportValues = undefined;
        this.ccmcApiService.search = undefined;
        this.ccmcApiService.transactions = undefined;
        this.ccmcApiService.configurations = undefined;
        if (this.dynamicNav[1].children[1]) {
          this.dynamicNav[1].children[1].children = [];
        }
        this.dynamicNav[1].children[0].badge.title = undefined;
        const dialogRef = this.dialog.open(TargetResponseDialogComponent, {
          data: resultMessage
        });
        dialogRef.afterClosed().subscribe(result => {
          if (this.activeLosService.activeLos === 'encompass' || this.activeLosService.activeLos === 'bytepro') {
            this.router.navigate(['loan-lookup']);
          } else {
            this.router.navigate(['file-selector']);
          }
        });
      } else {
        if (parsedResult.content && parsedResult.content.mapping) {
          // Retrieve Validation From existing mapping object
          let existingMappingCopy = JSON.parse(
            JSON.stringify(this.ccmcApiService.mapping)
          );
          for (let mappingItem of parsedResult.content.mapping) {
            let existingMappingIndex = existingMappingCopy.findIndex(
              (obj: any) => obj.fieldID === mappingItem.fieldID
            );
            if (
              existingMappingIndex > -1 &&
              existingMappingCopy[existingMappingIndex].validation
            ) {
              mappingItem.validation =
                existingMappingCopy[existingMappingIndex].validation;
            }
          }
          this.ccmcApiService.mapping = parsedResult.content.mapping;
        }
        if (parsedResult.content && parsedResult.content.transactions) {
          this.ccmcApiService.transactions = parsedResult.content.transactions;
        }
        await this.ccmcApiService.logExportResponse({
          assetID: this.assetService.getSelectedAssetId(),
          loanNumber: '',
          statusMessage: parsedResult.statusMessage,
          statusFlag: parsedResult.statusFlag
        });
        this.globalSearchService.initData();
        const errorMessage = {
          statusMessage: parsedResult.statusMessage,
          statusFlag: false
        };
        const dialogRef = this.dialog.open(TargetResponseDialogComponent, {
          data: errorMessage
        });
      }
    });
  }

  customerSearch(borrower: any, callback: any) {
    // init username
    let userName = this.amplifyService.username;
    // init request
    const request = {
      content: borrower,
      assetID: this.assetService.getSelectedAssetId(),
      user: userName
    };
    console.log('Request: \n', JSON.stringify(request));
    request.content.cognitoID = this.amplifyService.getCognitoId();
    // call search customer
    this.searchCustomer(request).subscribe(res => {
      console.log('Customer search response: ', res);
      const parsedResult = JSON.parse(JSON.stringify(res));
      console.log(parsedResult);
      if (parsedResult.error) {
        const errorMessage = {
          message: JSON.stringify(parsedResult.error.message),
          title: 'Insight Result'
        };

        const dialogRef = this.dialog.open(ErrorDialogComponent, {
          data: errorMessage
        });
      }
      if (parsedResult.statusFlag === true) {
        //   turn spinner off
        this.spinnerService.setShowSpinner(false);
        const payload = parsedResult.content;
        if (payload.length > 0) {
          const searchResult = payload;
          console.log(searchResult);
          callback(searchResult);
        } else {
          const noResult = [
            {
              firstName: 'No Result',
              lastName: '',
              taxID: '',
              CIF: '',
              address: ''
            }
          ];
          const searchResult = noResult;
          console.log(searchResult);
          callback(searchResult);
        }
      } else if (parsedResult.statusFlag === false) {
        const errorMessage = {
          message: parsedResult.statusMessage,
          title: 'Search Error'
        };

        const dialogRef = this.dialog.open(ErrorDialogComponent, {
          data: errorMessage
        });
      }
    });
  }

  autoCustomerSearch(borrower: any, callback: any) {
    let userName = this.amplifyService.username;
    const request = {
      content: borrower,
      assetID: this.assetService.getSelectedAssetId(),
      user: userName
    };
    console.log('Request: \n', JSON.stringify(request));
    request.content.cognitoID = this.amplifyService.getCognitoId();
    this.searchCustomer(request).subscribe(res => {
      console.log('Customer search response: ', res);
      const parsedResult = JSON.parse(JSON.stringify(res));
      console.log(parsedResult);
      if (parsedResult.error) {
        const errorMessage = {
          message: JSON.stringify(parsedResult.error.message),
          title: 'Insight Result'
        };

        const dialogRef = this.dialog.open(ErrorDialogComponent, {
          data: errorMessage
        });
      }
      if (parsedResult.statusFlag === true) {
        this.spinnerService.setShowSpinner(false);
        const payload = parsedResult.content;
        if (payload.length > 0) {
          const searchResult = payload;
          console.log(searchResult);
          callback(searchResult);
        } else {
          const noResult = [
            {
              firstName: 'No Result',
              lastName: '',
              taxID: '',
              CIF: '',
              address: ''
            }
          ];
          const searchResult = noResult;
          console.log(searchResult);
          callback(searchResult);
        }
      } else if (parsedResult.statusFlag === false) {
        this.spinnerService.setShowSpinner(false);
        if (
          parsedResult.statusMessage
            .toLowerCase()
            .includes('no customer record found')
        ) {
          const noResult = [
            {
              firstName: 'No Result',
              lastName: '',
              taxID: '',
              CIF: '',
              address: ''
            }
          ];
          const searchResult = noResult;
          console.log(searchResult);
          callback(searchResult);
        } else {
          const errorMessage = {
            message: parsedResult.statusMessage,
            title: 'Search Error'
          };

          const dialogRef = this.dialog.open(ErrorDialogComponent, {
            data: errorMessage
          });
          callback(parsedResult);
        }
      }
    });
  }

  assignBorrowers(party: any) {
    for (let i = 0; i < party.length; i++) {
      const CIFFields = party[i].CIFFields.split(',');
      CIFFields.forEach((cf: any) => {
        const cifIndex = this.ccmcApiService.mapping.findIndex(
          (f: any) => f.fieldID === cf.trim()
        );
        this.ccmcApiService.mapping[cifIndex].fieldValue = party[i].CIF;
      });
    }
  }

  searchCustomer(params: any) {
    console.log(params);
    return this.http
      .post(`${Buffer.from(environment.environmentURL, "base64").toString()}/fiserv/dna/search-customer`, params, this.httpOptions)
      .pipe(catchError(this.customErrorHandlerService.handleError));
  }

  export(params: any) {
    console.log(params);
    return this.http
      .post(`${Buffer.from(environment.environmentURL, "base64").toString()}/fiserv/dna/export-messages`, params, this.httpOptions)
      .pipe(catchError(this.customErrorHandlerService.handleError));
  }

  async insightBalanceCheck() {
    return new Promise((resolve) => {
      const zeroPad = (num: any, places: any) => String(num).padStart(places, '0')
      // Initialize counters to zero
      let creditCounter = 0, debitCounter = 0, totalCounter = 0;

      // Find index of a particular element in an array
      const msgIndex = this.ccmcApiService.mapping.findIndex(
        (msg: any) => msg.fieldID === MONETARY_GL_FIELD
      );
        console.log(msgIndex);
      // If element not found, exit function and return true
      if (msgIndex === -1) {
        return resolve(true);
      }

      console.log(this.ccmcApiService.mapping[msgIndex].fieldValue);
      // Check value of a field and set boolean variable accordingly
      const sendMonetaryGL = this.ccmcApiService.mapping[msgIndex].fieldValue === 'Y' ? true : false;

      // If value of previous field was Y, do some calculations
      if (sendMonetaryGL) {
        // Initialize variables to keep track of indexes and transaction information
        let glInstance = 1;
        let paddedGLInstance = zeroPad(glInstance, 2);
        let creditDebitInstance = CREDIT_DEBIT_FIELD.replace('*', `${paddedGLInstance}`);
        let creditDebitInstanceIndex = this.ccmcApiService.mapping.findIndex(
          (msg: any) => msg.fieldID === creditDebitInstance
        );
        let glAmountInstance = GL_AMOUNT_FIELD.replace('*', `${paddedGLInstance}`);
        let glAmountInstanceIndex = this.ccmcApiService.mapping.findIndex(
          (msg: any) => msg.fieldID === glAmountInstance
        );
        let currentGLTransactionID = this.ccmcApiService.mapping[creditDebitInstanceIndex].transactionID;
        let transactionIndex = this.ccmcApiService.transactions.findIndex((transaction: any) => transaction.transactionID === currentGLTransactionID)
        let currentTransaction = this.ccmcApiService.transactions[transactionIndex];

        // Loop until there are no more transactions or fields to process
        while (creditDebitInstanceIndex > -1 && glAmountInstanceIndex > -1) {
          // Get values of the credit/debit field and the amount field
          const creditOrDebitField = this.ccmcApiService.mapping[creditDebitInstanceIndex].fieldValue.toLowerCase();
          const amountField = this.ccmcApiService.mapping[glAmountInstanceIndex].fieldValue;
          const amountValue = +amountField;
          // Add to the appropriate counter based on credit/debit value
          if (creditOrDebitField.charAt(0) === 'd' && currentTransaction.display) {
            debitCounter += Math.abs(amountValue)
          } else if (creditOrDebitField.charAt(0) === 'c' && currentTransaction.display) {
            creditCounter += Math.abs(amountValue)
          }
          // Increment instance and update indexes for next loop iteration
          glInstance++;
          paddedGLInstance = zeroPad(glInstance, 2);
          creditDebitInstance = CREDIT_DEBIT_FIELD.replace('*', `${paddedGLInstance}`);
          creditDebitInstanceIndex = this.ccmcApiService.mapping.findIndex(
            (msg: any) => msg.fieldID === creditDebitInstance
          );
          if (creditDebitInstanceIndex > -1) {
            glAmountInstance = GL_AMOUNT_FIELD.replace('*', `${paddedGLInstance}`);
            glAmountInstanceIndex = this.ccmcApiService.mapping.findIndex(
              (msg: any) => msg.fieldID === glAmountInstance
            );
            currentGLTransactionID = this.ccmcApiService.mapping[creditDebitInstanceIndex].transactionID;
          }
          if (transactionIndex > -1) {
            transactionIndex = this.ccmcApiService.transactions.findIndex((transaction: any) => transaction.transactionID === currentGLTransactionID)
            currentTransaction = this.ccmcApiService.transactions[transactionIndex];
          }
        }

        // If credits and debits don't balance, open a dialog box for confirmation
        if (this.ccmcApiService.configurations.showGLBalancePrompt) {
          totalCounter = creditCounter - debitCounter;
          const message =
            'Are you sure you want to continue with the following Debit and Credit?';
          const dialogRef2 = this.dialog.open(DebitCeditCheckDialogComponent, {
            data: {
              message: message,
              total: totalCounter,
              credit: creditCounter,
              debit: debitCounter
            },
            panelClass: 'debit-credit__dialog'
          });

          // If user confirms, return true. Otherwise return false.
          dialogRef2.afterClosed().subscribe(data => {
            if (data === true) {
              return resolve(true);
            } else {
              return resolve(false)
            }
          });
        }
        // If credits and debits balance or there are no transactions to process, exit function and return true
        else {
          return resolve(true);
        }
      }
      // If value of previous field was not Y, exit function and return true
      else {
        return resolve(true);
      }
    })
  }

}
